// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------------- WRAPPER ---------------- */
.identity-form-wrapper {
  padding: 20px;
  display: flex;
  justify-content: flex-start;
  /* align with layout */
}

/* ---------------- CARD ---------------- */
.aptsi-card {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

/* ---------------- FORM ---------------- */
.form-control {
  height: 42px;
  border-radius: 4px;
}

.form-control:focus {
  box-shadow: none;
  border: 1px solid #0060d6;
}

/* ---------------- LABEL ---------------- */
label {
  font-weight: 500;
  margin-bottom: 5px;
}

/* ---------------- HEADER ---------------- */
h2 {
  margin-bottom: 20px;
  font-weight: 600;
}

/* ---------------- BUTTONS ---------------- */
.action-buttons {
  margin-top: 15px;
}

.btn-submit {
  background-color: #0060d6;
  color: #fff;
  margin-right: 10px;
}
.btn-submit:hover {
  background-color: #1a1a86;
}
.btn-submit:disabled {
  background-color: #9aa7b3;
}

.bar-section .tab-column.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.bar-section {
  max-width: 1400px;
  background: #ffffff;
  border-radius: 3px;
  margin-top: 5px;
}

.bar-section .row {
  margin: 0;
}

.bar-section .tab-column {
  background-color: #A4B4BF;
  color: white;
  text-align: center;
  padding: 12px;
  font-size: 16px;
  border: 1px solid rgb(204, 202, 202);
  transition: 0.3s;
}

.bar-section .tab-column:hover {
  background-color: #6f8fa4;
}

.bar-section .tab-column.active {
  background-color: #0060d6;
  font-weight: bold;
}

.bar-section .tab-column.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.identity-details {
  background: #f8f9fa;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/secure-blockchain/authoring-tools/Identity-management/identity-create-or-update/identity-create-or-update.component.scss"],"names":[],"mappings":"AAAA,8CAAA;AAEA;EACE,aAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;AAAF;;AAGA,2CAAA;AAEA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,yCAAA;AADF;;AAIA,2CAAA;AAEA;EACE,YAAA;EACA,kBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,yBAAA;AAFF;;AAKA,4CAAA;AAEA;EACE,gBAAA;EACA,kBAAA;AAHF;;AAMA,6CAAA;AAEA;EACE,mBAAA;EACA,gBAAA;AAJF;;AAOA,8CAAA;AAEA;EACE,gBAAA;AALF;;AAQA;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;AALF;AAOE;EACE,yBAAA;AALJ;AAQE;EACE,yBAAA;AANJ;;AAUA;EACE,YAAA;EACA,oBAAA;AAPF;;AAUA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAPF;;AAUA;EACE,SAAA;AAPF;;AAUA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,yBAAA;EACA,iBAAA;AAPF;;AAUA;EACE,YAAA;EACA,oBAAA;AAPF;;AAUA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAPF","sourcesContent":["/* ---------------- WRAPPER ---------------- */\n\n.identity-form-wrapper {\n  padding: 20px;\n  display: flex;\n  justify-content: flex-start;\n  /* align with layout */\n}\n\n/* ---------------- CARD ---------------- */\n\n.aptsi-card {\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 25px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n/* ---------------- FORM ---------------- */\n\n.form-control {\n  height: 42px;\n  border-radius: 4px;\n}\n\n.form-control:focus {\n  box-shadow: none;\n  border: 1px solid #0060d6;\n}\n\n/* ---------------- LABEL ---------------- */\n\nlabel {\n  font-weight: 500;\n  margin-bottom: 5px;\n}\n\n/* ---------------- HEADER ---------------- */\n\nh2 {\n  margin-bottom: 20px;\n  font-weight: 600;\n}\n\n/* ---------------- BUTTONS ---------------- */\n\n.action-buttons {\n  margin-top: 15px;\n}\n\n.btn-submit {\n  background-color: #0060d6;\n  color: #fff;\n  margin-right: 10px;\n\n  &:hover {\n    background-color: #1a1a86;\n  }\n\n  &:disabled {\n    background-color: #9aa7b3;\n  }\n}\n\n.bar-section .tab-column.disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.bar-section {\n  max-width: 1400px;\n  background: #ffffff;\n  border-radius: 3px;\n  margin-top: 5px;\n}\n\n.bar-section .row {\n  margin: 0;\n}\n\n.bar-section .tab-column {\n  background-color: #A4B4BF;\n  color: white;\n  text-align: center;\n  padding: 12px;\n  font-size: 16px;\n  border: 1px solid rgb(204, 202, 202);\n  transition: 0.3s;\n}\n\n.bar-section .tab-column:hover {\n  background-color: #6f8fa4;\n}\n\n.bar-section .tab-column.active {\n  background-color: #0060d6;\n  font-weight: bold;\n}\n\n.bar-section .tab-column.disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.identity-details {\n  background: #f8f9fa;\n  border: 1px solid #e5e5e5;\n  border-radius: 10px;\n  padding: 15px;\n  margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
